var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaQuestionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.935,
    cy: 13.033,
    fill: "#F5F5F8",
    r: 8.667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.019 16.284a1.083 1.083 0 11-2.167 0 1.083 1.083 0 012.167 0zm-2.253-5.325a1.09 1.09 0 01.367-.432c.157-.104.403-.202.802-.202.303 0 .6.094.8.244a.664.664 0 01.284.569c0 .191-.044.286-.084.345-.049.073-.134.155-.3.265a6.948 6.948 0 01-.28.174l-.006.004c-.102.061-.222.133-.34.211-.24.161-.528.384-.75.717a.812.812 0 101.352.901c.05-.074.134-.155.3-.266.083-.055.172-.108.28-.174l.007-.003c.101-.061.221-.133.34-.212.24-.16.527-.383.75-.716.23-.347.356-.76.356-1.246 0-.824-.39-1.461-.935-1.869-.522-.392-1.174-.569-1.774-.569-.684 0-1.25.173-1.703.475-.447.299-.736.69-.92 1.058a.813.813 0 101.454.726z",
    fill: "#7C8193"
  })));
}
export default __webpack_public_path__ + "media/icons/MA-Question-Icon-8b71112a.svg";
export { SvgMaQuestionIcon as ReactComponent };